module.exports = __webpack_public_path__ + "static/timeSaleImage-aa5143e4d4a659d4adee17be33a29e87.png";